import { FilterX, Search } from "lucide-react";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Button } from "../ui/button";

import { productFilterProps } from "@/types/AppTypes";
const ProductFilters = ({
  categories,
  brands,
  category,
  brand,
  search,
  handleSearchChange,
  setBrand,
  setCategory,
  handleClearFilters,
  productCount,
  totalProducts,
}: productFilterProps) => {
  const filterElements = [
    {
      id: "brand",
      label: "Brand",
      value: brand,
      onValueChange: setBrand,
      placeholder: "All Brands",
      options: brands,
    },
    {
      id: "category",
      label: "Category",
      value: category,
      onValueChange: setCategory,
      placeholder: "All Categories",
      options: categories,
    },
  ];

  return (
    <div className="">
      <h3 className="text-lg font-semibold mb-3">Filter Products</h3>
      <div className="space-y-4">
        <div className="space-y-2">
          <label htmlFor="search" className="block mb-2 text-sm font-medium">
            Search
          </label>
          <div className="relative">
            <Search className="absolute text-[#505050] left-2 top-2.5 h-4 w-4" />
          </div>
          <Input
            type="text"
            id="search"
            placeholder="Search products..."
            value={search}
            onChange={(e) => handleSearchChange?.(e.target.value)}
            className="w-full pl-8 text-palette-text border-gray-300   focus-visible:ring-2 focus-visible:ring-black/80 focus-visible:ring-offset-2 focus-visible:outline-none"
          />
        </div>
        {filterElements?.map((filter) => (
          <div key={filter?.id} className="space-y-2">
            <label htmlFor={filter?.id} className="block mb-2 text-sm font-medium">
              {filter?.label}
            </label>
            <Select value={filter?.value} onValueChange={filter?.onValueChange}>
              <SelectTrigger
                id={filter?.id}
                className="w-full border-gray-300 focus-visible:ring-2 focus-visible:ring-black/80 focus-visible:ring-offset-2 focus-visible:outline-none"
              >
                <SelectValue placeholder={filter?.placeholder} />
              </SelectTrigger>
              <SelectContent className="bg-white">
                {filter?.options?.map((option) => (
                  <SelectItem key={option?.name} value={option?.name}>
                   {option?.label || option?.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        ))}
        <Button
          variant="outline"
          onClick={handleClearFilters}
          className="group hover:text-white flex items-center w-full justify-center hover:bg-[#333333]"
        >
          <FilterX className="mr-2 group-hover:text-white" />
          Clear Filters
        </Button>
        <div className="pt-4 border-t">
          <h3 className="text-sm font-medium mb-2">Product Count</h3>
          <p className="text-sm text-gray-600">
            Showing {productCount} 
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductFilters;
